<template>
  <v-card style="margin-bottom: 20px;">
    <v-toolbar color="primary" :dark="protocol.dark">
      <v-toolbar-side-icon>
        <v-icon>{{ icon }}</v-icon>
      </v-toolbar-side-icon>
      <v-toolbar-title>{{ value.title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="deleteSlider">
        <v-icon >mdi-delete-forever</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container fluid grid-list-lg>
      <v-text-field box :label="inputLabel" :hint="inputHint" v-model="value.title"></v-text-field>
      <v-layout row wrap>
        <v-flex shrink style="width: 20%;max-width:75px;">
          <v-text-field v-model="part1Value" class="mt-0" hide-details single-line type="number" suffix="%" readonly></v-text-field>
        </v-flex>
        <v-flex style="width: 60%">
          <v-slider v-model="value.sliderValue" :max="100" :min="0" :step="1"></v-slider>
        </v-flex>
        <v-flex shrink style="width: 20%; max-width:75px;">
          <v-text-field v-model="part2Value" class="mt-0" hide-details single-line type="number" suffix="%" readonly></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex shrink style="width: 50%;">
          <h5>{{ part1.firstname }} {{ part1.lastname }}</h5>
        </v-flex>
        <v-flex shrink style="width: 50%;text-align:right;">
          <h5>{{ part2.firstname }} {{ part2.lastname }}</h5>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
export default {
  props: ["value", "part1", "part2", "inputLabel", "inputHint", "index", "protocol", "icon"],
  data() {
    return {
    };
  },
  computed: {
    part1Value: {
      get() {
        return 100-this.value.sliderValue
      }
    },
    part2Value: {
      get() {
        return this.value.sliderValue
      }
    }
  },
  methods: {
    deleteSlider() {
      this.$emit("delete-slider", this.index);
    }
  }
}
</script>